import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo, useState } from "react";
import { aggridHeaderClass } from "src/components/common/common";

import { ColDef, RowClickedEvent, RowDoubleClickedEvent } from 'ag-grid-community';
import Grid_Touch from "src/components/common/gridWrapper/Grid_Touch";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useGridSettingContent } from "src/utils/grid/GridSettingContent";
import { defaultColDef, getDefaultRowIndexColumnConfig } from "src/utils/grid/gridStyleUtils";
import { defaultKSK2030_R01DetailDto, KSK2030_R01DetailDto } from "./Dto_KSK2030_R01";
import { useKSK2030_R01Store } from "./Store_KSK2030_R01";
import { headerNames_KSK2030_R01_Detail } from './Util_KSK2030_R01';
import { formatDate, formatDateWithTime } from "src/utils/string/stringUtil";
import { CommonCodeColumn } from "src/utils/grid/GridColumnContent";
import { GridCustomColumnDefs } from "src/utils/grid/GridCustomColumnDefs";
import { onlyTouchGridStyle } from "src/utils/grid/gridFunctionUtil";

/**
 * 사용자 관리 테이블 컴포넌트
 * 사용자 정보를 표시하고 관리하는 테이블
 */

interface Props {
	// hoveredRowIndex: number | null;
	// setHoveredRowIndex: (hoveredRowIndex: number | null) => void;
	clickable: boolean;
	setClickable: (clickable: boolean) => void;
	gridRef: React.RefObject<AgGridReact<KSK2030_R01DetailDto> | null>;
}

const COLUMN_STATE_KEY = 'KSK2030_R01-detail-grid-column-state';

export const DetailTable_KSK2030_R01 = (props: Props) => {

	const { 
		// hoveredRowIndex, setHoveredRowIndex,
		clickable, setClickable,
		gridRef,
	} = props;

    const { 
		KSK2030_R01DetailList, setKSK2030_R01DetailList,
		insertKSK2030_R01DetailList,
		removeKSK2030_R01DetailList,
		updateKSK2030_R01DetailList,
		selectedKSK2030_R01DetailList, setSelectedKSK2030_R01DetailList, initSelectedKSK2030_R01DetailList,
		deletedKSK2030_R01List, removeDeletedKSK2030_R01List, addDeletedKSK2030_R01List,
        detailColumnState, setDetailColumnState,
		originalKSK2030_R01DetailList, setOriginalKSK2030_R01DetailList,
		modalVisible, setModalVisible,
		isDisabled,
	} = useKSK2030_R01Store();

    const { compCdList, downtimeValueList, jobTeamList, orgCdList, ordTypeList, workProcessList, workPlaceList, unitList,  } = useCommonCodeStore();

	// const gridWrapperRef = useRef<HTMLDivElement>(null); // 1. div를 위한 ref 생성
	const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);

    //const gridRef = useRef<AgGridReact>(null);

	const { 
		getRowId,
		settingRowIndex, 
		settingSecondColumnCount,
		createRowClassRules,
		createCellClassRules,
		paddedGridData,
		renderIndexCell,
		defaultRowIndexCellButton,
		rowIndexCellButtonType1,
		rowIndexCellButtonType2,
		handleSwitchButtonHandler,
		ensureSelectedRow,
	} = useGridSettingContent<KSK2030_R01DetailDto>({
		gridRef,
		key: 'downtimeNo',
		gridData: KSK2030_R01DetailList,
		defaultGridData: defaultKSK2030_R01DetailDto,
		selectedRow: selectedKSK2030_R01DetailList,
	});

	const getCellStyle = (params: any, key: string) => {
		return onlyTouchGridStyle(
			key,
			'downtimeNo',
		)(params);
	}
	

	const baseColumnDefs: ColDef<KSK2030_R01DetailDto>[] = useMemo(() => [
		...getDefaultRowIndexColumnConfig(),
		// {
		// 	headerName: '공정지시번호', colId: 'productWorkNo', field: 'productWorkNo', width: 190, 
		// 	cellStyle: (params: any) => getCellStyle(params, 'productWorkNo'),
		// 	editable: false,
		// },
		{
			headerName: '비가동번호', colId: 'downtimeNo', field: 'downtimeNo', width: 190, 
			cellStyle: (params: any) => getCellStyle(params, 'downtimeNo'),
			editable: false,
		},
		{
			headerName: '비가동사유', colId: 'downtimeCase', field: 'downtimeCase', width: 250, 
			cellStyle: (params: any) => getCellStyle(params, 'downtimeCase'),
			...CommonCodeColumn.options(downtimeValueList, false, undefined, undefined),
			editable: false,
		},
		{
			headerName: '비가동시작시간', colId: 'fromTime', field: 'fromTime', width: 200, 
			cellStyle: (params: any) => getCellStyle(params, 'fromTime'),
			valueFormatter: (params: any) => params.data?.fromTime ? formatDateWithTime(new Date(params.data?.fromTime)) : '',
			editable: false,
		},
		{
			headerName: '비가동종료시간', colId: 'toTime', field: 'toTime', width: 180, 
			cellStyle: (params: any) => getCellStyle(params, 'toTime'),
			valueFormatter: (params: any) => params.data?.toTime ? formatDateWithTime(new Date(params.data?.toTime)) : '',
			editable: false,
		}

		// {
		// 	headerName: '작업공정', colId: 'workplaceCd', field: 'workplaceCd', width: 100, 
		// 	cellStyle: (params: any) => getCellStyle(params, 'workplaceCd'),
		// 	...getWorkPlaceColumnOptions(
		// 		workPlaceList.filter(opt => opt.useYn === 'Y' && opt.orderYn === 'Y'), false
		// 	)
		// },
		

		// ...IndexParameterCell(),

	], [hoveredRowIndex, deletedKSK2030_R01List, KSK2030_R01DetailList, orgCdList, compCdList, workPlaceList, jobTeamList, ordTypeList, workProcessList]);



	const columnDefs: ColDef<KSK2030_R01DetailDto>[] = useMemo(() => {
		if (detailColumnState === null) {
			return baseColumnDefs;
		}
		return GridCustomColumnDefs<KSK2030_R01DetailDto>({
			baseColumnDefs,
			columnState: detailColumnState,
			headerNames: headerNames_KSK2030_R01_Detail,
			fallbackHeaderClass: aggridHeaderClass
		});
	}, [baseColumnDefs, detailColumnState, headerNames_KSK2030_R01_Detail]);


	const handleRowClick = useCallback((e: RowClickedEvent<KSK2030_R01DetailDto>) => {
		if (e.node.rowPinned === 'bottom') return;
		const rowData = e.data;
		if (!rowData) return;
		
		// 선택된 표와 정보가 같은지 확인 - salesEstimateNo를 우선 사용
		const currentKey = rowData.valueIndex;
		const selectedKey = selectedKSK2030_R01DetailList?.valueIndex;
		const isSelected = selectedKey === currentKey;
		
		if (isSelected) {
			// 선택만 해제 (DetailList 전체를 비우지 않음 — 더블클릭 시 데이터 소실 방지)
			setSelectedKSK2030_R01DetailList(defaultKSK2030_R01DetailDto);
		} else {
			setSelectedKSK2030_R01DetailList(rowData);
		}
	}, [selectedKSK2030_R01DetailList, setSelectedKSK2030_R01DetailList]);

	const handleRowDoubleClick = useCallback((e: RowDoubleClickedEvent<KSK2030_R01DetailDto>) => {
		if (e.node.rowPinned === 'bottom') return;
		const rowData = e.data;
		if (!rowData) return;

		//현재 기능 없음
	}, []);

	const pinnedBottomRow = useMemo(() => ([
		{
			rowIndex: '계',
			downtimeNo: KSK2030_R01DetailList.length.toLocaleString() + "건",
			editable: false,
		}
	]), [KSK2030_R01DetailList]);

	//+- 버튼 테이블에는 보류(조회하면 select한 행을 초기화)
	// useEffect(() => { ensureSelectedRow(); }, [KSK2030_R01DetailList, selectedKSK2030_R01List]);

    return (
		<GridContextWrapper<KSK2030_R01DetailDto>
			gridRef={gridRef}
			paddedGridData={paddedGridData}
			initSelected={initSelectedKSK2030_R01DetailList}
			defaultRowData={defaultKSK2030_R01DetailDto}
			baseColumnDefs={columnDefs}
			setColumnState={setDetailColumnState}
			localStorageKey={COLUMN_STATE_KEY}
			menuItems={undefined}
		>
			<Grid_Touch<KSK2030_R01DetailDto>
				ref={gridRef}
				rowData={paddedGridData}
				columnDefs={columnDefs}			defaultColDef={{
					...defaultColDef

				}}
				getRowId={getRowId}
				
				rowClassRules={createRowClassRules<KSK2030_R01DetailDto>({
					idKey: 'valueIndex',
					selectedList: selectedKSK2030_R01DetailList ? [selectedKSK2030_R01DetailList.valueIndex] : [],
					deletedList: [],
					
				})}
				onRowClicked={handleRowClick}
				onRowDoubleClicked={handleRowDoubleClick}
				onCellKeyDown={undefined}
				pinnedBottomRowData={pinnedBottomRow}	
				
				// Grid_Select 공통 로직 처리를 위한 props 전달
				setHoveredRowIndex={setHoveredRowIndex}		//마우스 오버 상태 이벤트를 위한 핸들러
				columnStateKey={COLUMN_STATE_KEY}			//컬럼 상태 (로컬스토리)	
				setColumnState={setDetailColumnState}		//컬럼 상태 저장
			/>
		</GridContextWrapper>
	)
}